import { unparse as convertToCSV } from "papaparse/papaparse.min";
import {
  List,
  Datagrid,
  TextField,
  ArrayField,
  SingleFieldList,
  ChipField,
  TextInput,
  Filter,
} from "react-admin";

import CustomActions from "../../../components/CustomActions";
import { ListPagination, downloadCsv } from "../../../utils";

const KitFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Flash ID" source="externalId" alwaysOn />
  </Filter>
);

const exporter = (data) => {
  const dataForExport = data.map((item) => ({
    "Conteúdo do Kit": item.samplesList
      ? item.samplesList.map(({ sample }) => sample).join(", ")
      : "",
    Flash_ID: item.externalId,
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: ["Conteúdo do Kit", "Flash_ID"],
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "kits");
};

const KitList = (props) => (
  <List
    hasCreate={true}
    perPage={25}
    bulkActionButtons={<div />}
    title="Lista de Kits"
    actions={<CustomActions showImportButton={false}/>}
    filters={<KitFilter />}
    exporter={exporter}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="Flash ID" source="externalId" />
      <ArrayField sortable={false} label="Laboratórios" source="kitsSamples">
        <SingleFieldList>
          <ChipField source="sample.lab.name" />
        </SingleFieldList>
      </ArrayField>
      <ArrayField sortable={false} label="Conteúdo do Kit" source="samplesList">
        <SingleFieldList>
          <ChipField source="sample" />
        </SingleFieldList>
      </ArrayField>
    </Datagrid>
  </List>
);

export default KitList;
